const STATS_PREFIX = 'seller_presence_package';

/**
 * Prefixed wrapper for the OBS stats.time function
 * @param {String} metric - The metric name
 * @param {Number} value - The value (in ms) to measure
 * @param {Object} options
 * @param {Number} options.rate - Sample rate represented by decimal point fraction [0-1]
 * @return {void}
 */
const genericTime = (stats) => (metric, value, options = {}) => stats.time(STATS_PREFIX, metric, value, options);

/**
 * Prefixed wrapper for the OBS stats.count function
 * @param {String} metric - The metric name
 * @param {Number} [value = 1] - The increment value (defaults to 1)
 * @param {Object} options
 * @param {Number} options.rate - Sample rate represented by decimal point fraction [0-1]
 * @return {void}
 */
const genericCount = (stats) => (metric, value = 1, options = {}) => stats.count(STATS_PREFIX, metric, value, options);

module.exports = {
    genericTime,
    genericCount
};
